:host {
  --h-space: #{space()};
  --h-around-left: 0;
  --h-around-right: 0;
  --h-around: 0;

  display: flex;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  letter-spacing: inherit;

  ::slotted(*) {
    // fix IE11 not wrapping text
    max-width: 100%;
    padding-left: calc(var(--h-space) * var(--h-around-left));
    padding-right: calc(var(--h-space) * var(--h-around-right));
    margin: 0;
  }

  ::slotted(*:not(:last-child)) {
    margin-right: calc(var(--h-space) * (1 - var(--h-around)));
  }

  ::slotted(stzh-show) {
    --show-display: block;
  }

  ::slotted(stzh-vspace),
  ::slotted(stzh-hspace),
  ::slotted(stzh-row),
  ::slotted(stzh-container),
  ::slotted(stzh-section) {
    align-self: stretch;
    flex-grow: 1;
  }
}

:host(:empty),
:host([around]:not([around="false"])) {
  --h-around-left: 1;
  --h-around-right: 1;
  --h-around: 1;
}

:host(:empty) {
  width: var(--h-space);
}

:host([around-left]:not([around-left="false"])) {
  --h-around-left: 1;
  --h-around: 1;
}

:host([around-right]:not([around-right="false"])) {
  --h-around-right: 1;
  --h-around: 1;
}

/* Border variants */

:host([border="left"]),
:host([border="left-right"]) {
  border-left: 1px solid $baseBorderColor;
}

:host([border="right"]),
:host([border="left-right"]) {
  border-right: 1px solid $baseBorderColor;
}

/* Space variants */

@each $spaceCurve, $value in $spaceCurves {
  $defaultSize: map-get($value, 'size');
  $breakpointSizes: map-get($value, 'sizes');

  // :host([curve="#{$spaceCurve}"]) > .stzh-h-space {
  :host([curve="#{$spaceCurve}"]) {
    --h-space: #{space($defaultSize)};

    @each $breakpoint, $size in $breakpointSizes {
      @include mq($from: $breakpoint) {
        --h-space: #{space($size)};
      }
    }
  }
}

@mixin spaceProps($breakpoint: null) {
  @each $space, $value in $spaceSizes {
    @if $breakpoint {
      // :host([size-#{$breakpoint}="#{$space}"]) > .stzh-h-space {
      :host([size-#{$breakpoint}="#{$space}"]) {
        @include mq($from: $breakpoint) {
          --h-space: #{$value};
        }
      }
    } @else {
      // :host([size="#{$space}"]) > .stzh-h-space {
      :host([size="#{$space}"]) {
        --h-space: #{$value};
      }
    }
  }
}

@include spaceProps();

@each $breakpoint, $size in $breakpoints {
  @include spaceProps($breakpoint);
}

.stzh-hspace {
  flex-grow: 1;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin: 0;

  &--border-left {
    border-left: 1px solid $baseBorderColor;
  }

  &--border-right {
    border-right: 1px solid $baseBorderColor;
  }

  /* Justify content variants */

  &--justify-center {
    justify-content: center;
  }

  &--justify-end {
    justify-content: flex-end;
  }

  &--justify-between {
    justify-content: space-between;
  }

  &--justify-around {
    justify-content: space-around;
  }

  &--justify-evenly {
    justify-content: space-evenly;
  }

  /* Align items variants */

  &--items-end {
    align-items: flex-end;
  }

  &--items-center {
    align-items: center;
  }

  &--items-baseline {
    align-items: baseline;
  }

  &--items-stretch {
    align-items: stretch;
  }
}
